import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 项目期初类型
 */
class ProjectInceptionType extends UltMeta {
    SELL = new Meta(2, "销售期初");
    BUY = new Meta(1, "采购期初");
}

export const PROJECT_INCEPTION_TYPE = new ProjectInceptionType();
